namespace TabAurous {
    export interface QCRequest extends Serenity.ListRequest {
        ProductId?: number;
        ProcessId?: number;
        DepartmentId?: number;
    }
}
